module.exports = __webpack_public_path__ + "static/img/jsmagic1pict3.3ed00c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jsmagic1pict3.jpg
// module id = gdPK
// module chunks = 0